import React, { Component } from 'react';
import { _setTime } from './Function';
import SideBar from './SideBar';
import Loading from './Loading';
import DashboardInfo from './Dashboard.info';
import '../css/Dashboard.css';

class Dashboard extends Component {
  constructor() {
    super();
    this.state={ 
      loadingShow: true,
      dashboard: {},
      is_dashboard: true,
      tel: '',
      mobile: '',
      email: '',
      current_address: {
        c_address_no: '',
        c_address_moo: '',
        c_address_village: '',
        c_address_road: '',
        c_address_soi: '',
        c_district_id: 0,
        c_amphur_id: 0,
        c_province_id: 0,
        c_zipcode: ''
      }
    };
  }

  onLoading = (v) => {
    this.setState({ loadingShow: v })
  }

  update = (t, e) => {
    this.setState({ [t]: e.target.value })
  }

  onAddTime = () => { _setTime() }

  render() {
    return (
      <div className="fix-content content-bar-bigger" onClick={(e) => this.onAddTime()}>
        <div className="welcome_text">
              <div className="welcome_head">
              ยินดีต้อนรับ
              </div>
              <div className="welcome_detail">
                  อัพเดทข้อมูลล่าสุดเมื่อ 10 พฤษภาคม 2562
              </div>
          </div>
        <Loading show={this.state.loadingShow} />
        <SideBar onRefresh={false} />

        <div className="content-bar">

          <DashboardInfo onLoading={this.onLoading}/>

          <div className="card">
            <div className="card-title">
              <div className="card-icon"><i className="fas fa-users"></i></div>
              <div className="card-title-text">ผู้รับผลประโยชน์</div>
            </div>
             <div className="card-content">
              <div className="no-data">ไม่พบผู้รับผลประโยชน์</div>
            </div>
          </div>

          <div className="card">
            <div className="card-title">
              <div className="card-icon"><i className="fas fa-dollar-sign"></i></div>
              <div className="card-title-text">เงินปันผลเฉลี่ยคืน</div>
            </div>
            <div className="card-content">
              <div className="no-data">ไม่พบเงินปันผลเฉลี่ยคืน</div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default Dashboard;